export const time = {
  second: {
    middle: 'сек.',
    short: 'с.'
  }
};
